import { MqlWordSeparator } from '../Mql';
import { startsWithMqlTriggerCharacter } from '../MqlHelper';
import { KeywordColor } from './KeywordColor';

export const getKeywordColorArray = (
    input: string | undefined,
    keywordColors: KeywordColor[] | undefined,
    defaultColor: string
): KeywordColor[] =>
    input
        ? input.split(MqlWordSeparator).map((word) => {
              const originalFirstWord = word;
              let updatedWord = word;
              if (startsWithMqlTriggerCharacter(word)) {
                  updatedWord = word?.substring(1);
              }
              const foundKeywordColor = keywordColors?.find(
                  (keywordColor) => keywordColor.keyword.toLowerCase() === updatedWord.toLowerCase()
              );
              return {
                  keyword: originalFirstWord,
                  color: foundKeywordColor?.color ?? defaultColor,
                  backgroundColor: foundKeywordColor?.backgroundColor ?? 'transparent',
              } as KeywordColor;
          })
        : [];
